import React, { Component } from 'react'
import { connect } from 'react-redux'

import Typography from '@mui/material/Typography'
import { getHost } from '../utils/utils'

import logo from '../assets/images/logo.png';
import logoW from '../assets/images/webp/logo.webp';

class ProLogo extends Component {
    render() {
        const { isAuthed, userInfo } = this.props
        const isPro = (isAuthed && userInfo.isPro)

        const isJH = (window.VIEW_TYPE === 'business')

        return (
            <>
                <a href={getHost()} style={{color:"#424242", textDecoration:"none", display: 'flex'}}>
                    {!isJH&&<picture style={{height: 38}}>
                        <source type="image/webp" srcSet={logoW} />
                        <img style={{height: 38}} src={logo} alt="JobSwipe" />
                    </picture>  }
                    {isJH&&<img style={{height:40}} src="https://jobhunt.co.il/wp-content/themes/jobboard/assets/images/jobhunt-ntl.png" alt="סוכן טאלנטים אישי לעולם ההיי-טק"/>}
                </a>
                {(!isJH && isPro)&&<Typography className="proLogo" variant="h6">Pro</Typography>}
            </>
        )
    }
}

function mapStateToProps(state) {
    const { isAuthed, userInfo } = state.authUser;

    return {
        isAuthed, userInfo
    }
}

export default connect(mapStateToProps)(ProLogo)